import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import './LoginForm.css'

import AdminFoto from '../assets/Oggetto-vettoriale-avanzato.png'
import SplashLoginBtn from '../components/SplahsLoginBtn'

class LoginForm extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    const {error, onPasswordForgot, handleSubmit} = this.props
    return (
      <form onSubmit={handleSubmit}>

        <div className="panel panel-default panel-border-login">
          <h2 className="login-title">LOG-IN</h2>
          <div className="panel-body">

            <a href="#" className="btn-social btn-outline"><img className="login-admin-logo" src={AdminFoto} /></a>

            <div className="login-input-box">
              <Field name="username" component="input" type="text" placeholder="E-MAIL o CODICE FISCALE" className="inputLogin" />
              <Field name="password" component="input" type="password" placeholder="PASSWORD" className="inputLogin" />
              {error && <h5>Username o password errati</h5>}
            </div>
            <SplashLoginBtn type="submit">ACCEDI</SplashLoginBtn>
          </div>
        </div>

        {onPasswordForgot &&
        <div style={{textAlign: 'center'}}>
          <span className="pas">
            <a onClick={() => onPasswordForgot()}>
              <i className="glyphicon glyphicon-lock">{}</i> Hai necessità di cambiare la password oppure l'hai dimenticata? Clicca qui
            </a>
          </span>
        </div>}
      </form>
    )
  }
}

export default reduxForm({
  form: 'login'
})(LoginForm)



// WEBPACK FOOTER //
// ./src/components/LoginForm.js